module.exports = __webpack_public_path__ + "img/paul_d_2.0004a9a7.png";